// src/components/forms/FileUpload.jsx
import React from "react";

export default function FileUpload({ onChange }) {
  function handleChange(e) {
    const files = Array.from(e.target.files);
    onChange(files); // pass File objects back to parent
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Room Photos
      </label>
      <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleChange}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-primary/10 file:text-primary hover:file:bg-primary/20"
      />
    </div>
  );
}
